var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemoveOnlineReservation = function SvgRemoveOnlineReservation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 23C32 27.9705 27.9706 32 23 32C18.0294 32 14 27.9705 14 23C14 18.0294 18.0294 14 23 14C27.9706 14 32 18.0294 32 23ZM28 24C28.5523 24 29 23.5523 29 23C29 22.4477 28.5523 22 28 22H18C17.4477 22 17 22.4477 17 23C17 23.5523 17.4477 24 18 24H28Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1424 2H4.35498C3.59423 2 3.08635 2.61093 3.2206 3.36457L6.43616 16.6354C6.57042 17.389 7.29596 18 8.05671 18H13.7646C14.7545 16.1755 16.2692 14.6772 18.1063 13.7078L15.5633 10.5247H14.5564L15.3844 14.0486H13.4108L11.2964 5.05034H14.1963C16.6802 5.05034 18.1469 5.92157 18.5747 7.74202C18.8558 8.93832 18.4196 9.65348 17.3067 10.1736L19.738 13.0166C20.7648 12.6813 21.8612 12.5 23 12.5C24.4882 12.5 25.9041 12.8096 27.1868 13.3679L24.7629 3.36457C24.6287 2.61093 23.9032 2 23.1424 2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5908 6.41568H14.4768C15.6718 6.41568 16.317 6.81878 16.534 7.74202C16.7723 8.75628 16.3062 9.17238 15.2724 9.17238H14.2386L13.5908 6.41568Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74967 15.2955L1.91372 3.57983L0.0143796 14.1616C-0.0971787 14.7878 0.452495 15.2955 1.24214 15.2955H4.74967Z",
    fill: "currentColor"
  })));
};
export default SvgRemoveOnlineReservation;